module.exports = __webpack_public_path__ + "img/he.1243ac49.svg";